import { connect } from "react-redux";
import OrderImg from "../../../../assets/images/icon/list.svg";
import { EmptyMessage, EmptyAddress, EmptyImg } from "./style";

const Empty = (props) => {
  const { message, theme } = props;

  return (
    <>
      <EmptyAddress className="text-center mt-4">
        <EmptyImg className="img-fluid" src={OrderImg} alt="" />
        <EmptyMessage className="mt-2 f-13" theme={theme}>
          {message}
        </EmptyMessage>
      </EmptyAddress>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps)(Empty);
